var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLoad)?_c('div',{staticClass:"page-loading"},[_c('div',{staticClass:"loadingSpinner"},[_vm._m(0),_c('div',{staticClass:"loadText"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loadIcon"},[_c('em'),_c('em'),_c('em'),_c('em')])
}]

export { render, staticRenderFns }